import * as z from 'zod'

const email = z
	.string({
		// required_error: 'Email is a required field.',
	})
	.min(1, {
		// message: 'Email is a required field.',
		message: 'regexError',
	})
	.email({
		// message: 'The email format is invalid.'
		message: 'regexError',
	})

const password = z
	.string({
		// required_error: 'Password is required field.'
	})
	.min(8, {
		// message: 'Password must be between 8 and 20 characters.',
		message: 'lengthError',
	})
	.max(20, {
		// message: 'Password must be between 8 and 20 characters.',
		message: 'lengthError',
	})
	.regex(/^(?!.*[()<>‘“;]).*$/, {
		// message: '( ) < > ‘ “ ; are not allowed.',
		message: 'regexError',
	})

const cPassword = z.string({ message: '' })

const authCode = z.string().min(6, { message: '' }).max(6, { message: '' })

const policy = z
	.boolean()
	.default(false)
	.refine((data) => data === true, {
		// message: 'Please check the box to complete the Sign Up process.',
	})

export const signInSchema = z.object({
	email,
	password,
})

const agreements = z.object({
	stepin: policy,
	privacy: policy,
	age14: policy,

	marketing: policy,
})

export const passwords = z
	.object({
		getPassword: password,
		confirmPassword: cPassword,
	})
	.refine(
		(values) => {
			return values.getPassword === values.confirmPassword
		},
		{
			// message: 'The password does not match.',
			message: 'confirmError',
			path: ['confirmPassword'],
		}
	)

export const signUpSchema = z.object({
	registerAgreements: agreements,
	getEmail: email,
	verifyEmail: authCode,
	verifyStatus: z.boolean(),
	getPasswords: passwords,
})

export type SignInType = z.infer<typeof signInSchema>
export type SignUpType = z.infer<typeof signUpSchema>
export type AgreementsType = z.infer<typeof agreements>
export type PasswordsType = z.infer<typeof passwords>
